module.exports = __webpack_public_path__ + "static/media/brand-logo.6a81bed7.png";